import React, { useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import LoginContext from '../../context/LoginContext/LoginContext';
import { ExactianLoader } from '../../ui/components';

const LoginCC = () => {

  const { token } = useParams();

  const { loginCC } = useContext(LoginContext);

  useEffect(() => {
    loginCC(token);
    // eslint-disable-next-line
  }, [])

  return (
    <div className='d-flex justify-content-center align-items-center h-100'>
      <ExactianLoader />
    </div>
  )
}

export default LoginCC